import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-cream pt-20 pb-10 relative z-[2]" data-testid="site-footer">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 pb-16 border-b border-ink/10">
          <div className="lg:col-span-5">
            <Logo size={32} />
            <p className="text-ink/70 mt-5 max-w-[36ch]">
              AI receptionists, lead capture, and auto-booking — built for service businesses.
              HIPAA-compliant flows for healthcare and dental.
            </p>
            <div className="flex flex-wrap gap-2 mt-6">
              <span className="badge-compliance"><span className="dot"></span>HIPAA</span>
              <span className="badge-compliance"><span className="dot"></span>SOC 2 aligned</span>
              <span className="badge-compliance"><span className="dot"></span>BAA available</span>
            </div>
          </div>
          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="mono text-xs uppercase tracking-wider text-mute mb-4">Product</div>
              <ul className="space-y-2.5 text-[15px]">
                <li><a href="/#services" className="hover:text-rust">Services</a></li>
                <li><a href="/#how" className="hover:text-rust">How it works</a></li>
                <li><a href="/#industries" className="hover:text-rust">Industries</a></li>
                <li><a href="/#pricing" className="hover:text-rust">Pricing</a></li>
              </ul>
            </div>
            <div>
              <div className="mono text-xs uppercase tracking-wider text-mute mb-4">Company</div>
              <ul className="space-y-2.5 text-[15px]">
                <li><a href="#" className="hover:text-rust">About</a></li>
                <li><a href="#" className="hover:text-rust">Customers</a></li>
                <li><a href="#" className="hover:text-rust">Affiliates</a></li>
                <li><a href="#" className="hover:text-rust">Contact</a></li>
              </ul>
            </div>
            <div>
              <div className="mono text-xs uppercase tracking-wider text-mute mb-4">Trust &amp; legal</div>
              <ul className="space-y-2.5 text-[15px]">
                <li><a href="#" className="hover:text-rust">HIPAA &amp; BAA</a></li>
                <li><a href="#" className="hover:text-rust">Security</a></li>
                <li><a href="#" className="hover:text-rust">Privacy</a></li>
                <li><a href="#" className="hover:text-rust">Terms</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-wrap items-center justify-between gap-4 text-sm text-ink/60">
          <div>© 2026 AI Automate Systems · Built in the USA.</div>
          <div className="mono text-xs uppercase tracking-wider">All systems operational</div>
        </div>
        <div className="display text-[14vw] leading-none tracking-tighter mt-10 select-none" style={{ color: "rgba(22,17,13,0.06)" }}>
          ai automate<span className="display-italic text-rust">.</span>
        </div>
      </div>
    </footer>
  );
}
